// schema/marks/bold.ts
var BOLD_SCHEMA = () => ({
  parseDOM: [{ tag: "strong" }, { tag: "b" }],
  toDOM: () => ["b"]
});
var BOLD_KEY = "bold";
var BOLD = {
  [BOLD_KEY]: BOLD_SCHEMA
};
export {
  BOLD,
  BOLD_KEY,
  BOLD_SCHEMA
};
